import { useEffect, useState } from "react";

const MyToast = ({ triggerCondition, setTriggerCondition, message, isErr }) => {
  const [isOpen, setIsOpen] = useState(false);

  // Automatically open/close the modal based on the trigger condition
  useEffect(() => {
    setIsOpen(triggerCondition);
  }, [triggerCondition]);

  const closeModal = () => {
    setIsOpen(false);
    setTriggerCondition(false);
  };

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          {/* Overlay */}
          <div
            className="fixed inset-0 bg-black opacity-50"
            onClick={closeModal}
          ></div>

          {/* Modal Content */}
          <div className="relative bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
            <h2 className="text-2xl font-bold text-gray-800 mb-4 text-center">
              HALISAHABUL
            </h2>
            <p className="text-gray-600 mb-6 text-center">
              {message ||
                "Discover the easiest way to pitch and rent properties!"}
            </p>
            <button
              onClick={closeModal}
              className={`w-full px-4 py-2 ${
                isErr
                  ? "bg-red-500 hover:bg-red-700"
                  : "bg-[#4d9041] hover:bg-[#62a556]"
              } text-white rounded-lg transition cursor-pointer`}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default MyToast;
